import { StylesConfig } from "react-select";
import styled from "styled-components";

export const reactSelectStyles: StylesConfig<any, any, any> = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: 'var(--black-100)',
    height: '3rem',
    borderColor: 'transparent',
    cursor: 'pointer',
    marginTop: '8px',
    fontFamily: 'Inter',
    padding: '0rem 0.3rem',
    ...(state.isFocused && {
      borderColor: 'var(--primary)',
      boxShadow: 'none'
    }),

    ":hover": {
      borderColor: 'var(--primary)',
    }
  }),

  menu: (baseStyles) => ({
    ...baseStyles,
    zIndex: '9999',
    backgroundColor: 'var(--black-100)',
    fontFamily: 'Inter',
  }),

  option: (baseStyles) => ({
    ...baseStyles,
    backgroundColor: 'var(--black-100)',
    ":hover": {
      backgroundColor: 'var(--black-300)'
    },
    fontFamily: 'Inter',
    cursor: 'pointer'
  }),

  placeholder: (baseStyles) => ({
    ...baseStyles,
    color: '#737373',
  }),

  singleValue: (baseStyles) => ({
    ...baseStyles,
    color: 'var(--white)',
    border: 'none'
  }),

  input: (baseStyles) => ({
    ...baseStyles,
    color: 'var(--white)',
  })
}

export const Wrapper = styled.div`
  width: 100%;

  small {
    color: #ff6565;
    font-size: 13.5px;
    font-family: IBM Plex Sans;
    line-height: 12px;
    margin-top: 0.5rem;
  }

  label {
    font-style: normal;
    font-weight: normal;
    font-size: 0.9rem;
    color: var(--grey-100);
  }
`;

export const SuggestionList = styled.div`
  background-color: var(--black-300);
  position: absolute;
  z-index: 999;
  width: 100%;
  border-radius: 5px;
  max-height: 200px;
  overflow-y: auto;

  p {
    font-size: 0.75rem;
    color: var(--grey-100);
  }

  p,
  span,
  li {
    padding: 0.7rem;
  }

  .error {
    color: var(--red);
  }

  li {
    cursor: pointer;
    border-radius: 5px;
    font-size: 0.9rem;
    list-style-type: none;

    &:hover {
      background-color: var(--black-100);
      border-radius: 0px;
    }
  }
`;
